import {OFFER_MODAL_ROUTE_PARAM} from "../../components/offer_modal/constants";

/**
 * Params that only drive a routed modal. They change `location.search` without changing anything the
 * listing itself renders, so they must not invalidate the listing render memo - re-rendering the whole
 * listing inside a click handler is the dominant INP processing cost on this page. For the
 * same reason they must never end up in listing-built hrefs (pagination, map): the memo will not
 * rebuild those links when only a modal param changes.
 */
export const MODAL_ONLY_SEARCH_PARAMS = [OFFER_MODAL_ROUTE_PARAM];

/**
 * Returns `search` with modal-only params stripped, always normalized through URLSearchParams. The
 * result must be produced the same way whether or not anything was stripped - returning the raw
 * string in the untouched case would keep the leading "?" and the key would still differ between
 * "modal closed" and "modal open", which is exactly what this guards against.
 */
export const getListingLayoutSearchKey = (search: string): string => {
    const searchParams = new URLSearchParams(search);

    MODAL_ONLY_SEARCH_PARAMS.forEach((param) => searchParams.delete(param));

    return searchParams.toString();
};
import {OFFER_MODAL_ROUTE_PARAM} from "../../components/offer_modal/constants";

/**
 * Params that only drive a routed modal. They change `location.search` without changing anything the
 * listing itself renders, so they must not invalidate the listing render memo - re-rendering the whole
 * listing inside a click handler is the dominant INP processing cost on this page. For the
 * same reason they must never end up in listing-built hrefs (pagination, map): the memo will not
 * rebuild those links when only a modal param changes.
 */
export const MODAL_ONLY_SEARCH_PARAMS = [OFFER_MODAL_ROUTE_PARAM];

/**
 * Returns `search` with modal-only params stripped, always normalized through URLSearchParams. The
 * result must be produced the same way whether or not anything was stripped - returning the raw
 * string in the untouched case would keep the leading "?" and the key would still differ between
 * "modal closed" and "modal open", which is exactly what this guards against.
 */
export const getListingLayoutSearchKey = (search: string): string => {
    const searchParams = new URLSearchParams(search);

    MODAL_ONLY_SEARCH_PARAMS.forEach((param) => searchParams.delete(param));

    return searchParams.toString();
};
